module.exports = __webpack_public_path__ + "static/img/share_img.57095a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share_img.png
// module id = UoLx
// module chunks = 0